"use client";

import SignupEntryCard from "@/components/auth/SignupEntryCard";

export const dynamic = "force-dynamic";

export default function Page() {
	return <SignupEntryCard showOneClickSeparator />;
}
